import { BaseDto } from "./base.dto";

export class BillingSubscriptionInvoiceDto extends BaseDto{
  businessEntityId: number;
  billingSubscriptionFrequencyId: number;
  latestRegularInvoiceId?: number;
  latestRegularMerchantId?: number;
  latestRegularInvoiceDate?: Date;
  nextRegularInvoiceDate?: Date;
  isSubscriptionChange?: boolean;
}